module.exports = __webpack_public_path__ + "img/location.71bf1fb8.png";